const stopped = () => ({ state: { speaking: false, thinking: false } });
const responseDone = event => ({ generating: false, state: { thinking: false },
  fatal: event.response?.status === 'failed' });
const providerError = event => ({ fatal: event.error?.code !== 'response_cancel_not_active' });

const EFFECTS = {
  'response.created': () => ({ generating: true, state: { thinking: true } }),
  'output_audio_buffer.started': () => ({ state: { speaking: true, thinking: false } }),
  'output_audio_buffer.stopped': stopped,
  'output_audio_buffer.cleared': stopped,
  'input_audio_buffer.speech_started': stopped,
  'response.done': responseDone,
  'conversation.item.input_audio_transcription.failed': () => ({ state: { error: 'transcription' } }),
  error: providerError,
};

export function voiceEventEffect(event) {
  const handler = Object.hasOwn(EFFECTS, event.type) ? EFFECTS[event.type] : null;
  return handler ? handler(event) : {};
}